import React from 'react';

import { PropTypes } from 'prop-types';

import Address from './Address';
import AdditionalData from './AdditionalData';
import GeneralData from './GeneralData';
import PersonalData from './PersonalData';

const PhysicalPerson = ({ isInsuredPerson }) => {
  return (
    <div className="form-fields">
      <GeneralData />
      <PersonalData />
      <Address isInsuredPerson={isInsuredPerson} />
      <AdditionalData isInsuredPerson={isInsuredPerson} />
    </div>
  );
};

PhysicalPerson.propTypes = {
  isInsuredPerson: PropTypes.bool.isRequired,
};

export default PhysicalPerson;
